import { Box, Slider, Theme, ThemeProvider } from "@mui/material";
import IconFilterAge from "assets/icons/filter/ic_filter_age.svg";
import { completionYMMarks } from "common/consts/estates";
import React, { useCallback, useMemo } from "react";
import { SliderCaption } from "./SliderCaption";
import { useSliderHooks } from "./hooks";

const thumbClassName = "completion-ym-thumb";

export const CompletionYMSlider = React.memo(
  (props: {
    sliderTheme: Theme;
    id: string;
    styles: Record<string, string>;
    valueFrom: number;
    valueTo: number;
    formattedCompletionYMFrom: string;
    formattedCompletionYMTo: string;
    onChange: (
      event: Event,
      value: number | number[],
      activeThumb: number
    ) => void;
  }) => {
    const hooks = useSliderHooks({ onChange: props.onChange }, thumbClassName);

    const { sliderRef } = hooks;

    const marks = useMemo(
      () =>
        completionYMMarks.map((x) => ({
          value: x.value,
          label: x.displayAlways ? x.label.replace(/[築年]/g, "") : ""
        })),
      []
    );

    const valueText = useCallback((value: number) => {
      return completionYMMarks.at(value)?.label ?? "";
    }, []);

    const valueLabelFormat = useCallback(
      (value: number) => {
        return valueText(value);
      },
      [valueText]
    );

    return (
      <ThemeProvider theme={props.sliderTheme}>
        <Box className={props.styles.box}>
          <Box className={props.styles.ic_tit}>
            <img src={IconFilterAge} alt="築年数" />
          </Box>
          <Box className={props.styles.setting}>
            <SliderCaption
              captionRef={hooks.captionRef}
              arrowRef={hooks.arrowRef}
              styles={props.styles}
              captionLeft={hooks.captionLeft}
              captionRight={hooks.captionRight}
              arrowLeft={hooks.arrowLeft}
              arrowRight={hooks.arrowRight}
              title="築年数"
              fromCaption={[props.formattedCompletionYMFrom]}
              toCaption={[props.formattedCompletionYMTo]}
              chaseThumb={hooks.chaseThumb}
            />
            <Slider
              ref={sliderRef}
              value={[props.valueFrom, props.valueTo]}
              onChange={hooks.onChange}
              valueLabelFormat={valueLabelFormat}
              aria-labelledby={props.id}
              getAriaValueText={valueText}
              valueLabelDisplay="off"
              marks={marks}
              min={0}
              max={completionYMMarks.length - 1}
              step={null}
              slotProps={{
                thumb: {
                  className: thumbClassName
                }
              }}
            />
          </Box>
        </Box>
      </ThemeProvider>
    );
  }
);
